import { CheckoutTermAcceptService } from './../../../../services/checkout-term-accept/checkout-term-accept.service';

import { Component, ElementRef, Inject, ViewChild, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { StorageService } from '@toro/common/libs/toro-storage';
import { OrderMarketTypeEnum } from "@toro/common/shared/enum/orders/market-type.enum";
import { OrderStatus } from "@toro/common/shared/enum/orders/order-status.enum";
import { OrderOriginTypeEnum } from "@toro/common/shared/enum/orders/origin-type.enum";
import { OrderSideEnum } from "@toro/common/shared/enum/orders/side.enum";
import { SegmentMarketTypeEnum } from "@toro/common/shared/enum/segment/segment-market-type.enum";
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { AppState } from "@toro/common/shared/interfaces/app-state.interface";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { FinancePosition } from '@toro/common/shared/models/pos-risk/finance-position';
import { StockOrderType } from "@toro/common/shared/models/stocks-exchange/stock-order.model";
import { StrategyRequestLegPriceType } from "@toro/common/shared/models/stocks-exchange/strategy-request-leg-price-type.enum";
import { StrategyRequestLegValidityType } from "@toro/common/shared/models/stocks-exchange/strategy-request-leg-validity-type.enum";
import { StrategyRequestOrderType } from "@toro/common/shared/models/stocks-exchange/strategy-request-order-type.enum";
import { StrategyRequest } from "@toro/common/shared/models/stocks-exchange/strategy-request.model";
import { DialogsService } from "@toro/common/shared/services/dialogs.service";
import { FeatureFlagService } from '@toro/common/shared/services/feature-flag/feature-flag.service';
import { Icvm617Service } from "@toro/common/shared/services/icvm-617";
import { SettingsService } from "@toro/common/shared/services/settings/settings.service";
import { UserSantanderService } from '@toro/common/shared/services/users/user-santander.service';
import { IUserSantanderOperationLimit } from '@toro/common/shared/interfaces/user-santander-operation-limit.interface';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { TrackingActions } from "@toro/common/shared/state-management/tracking/tracking.action";
import { SantanderSuitabilityCookieKeys } from 'apps/stock/src/app/enum/santander-suitability-cookie-keys.enum';
import { getSantanderEnumFromString, SantanderSuitabilityEnum } from 'apps/stock/src/app/enum/santander-suitability.enum';
import { FittingAcceptResponse, FittingResponse } from 'apps/stock/src/app/shared/models/santander-suitability/santander-suitability.model';
import { Observable, Subscription } from "rxjs";
import { filter, first, tap } from "rxjs/operators";
import { CheckoutScenarioSettings } from "../../../../../partials/stock/checkout/checkout-scenario.settings";
import { TrackingsService } from '../../../../../services/tracking.service';
import { StocksExchangeCheckoutAction } from "../../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action";
import { StocksExchangeCheckoutEffects } from "../../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.effects";
import { SuitabilityBypassAgreementActions } from "../../../../../state-management/suitability-bypass-agreement/suitability-bypass-agreement.action";
import * as financeSelectors from '../../../../selectors/finance.selectors';
import { CheckoutNotifierActionType, CheckoutNotifierProductType, CheckoutNotifierService } from "../../../../services/checkout-notifier/checkout-notifier.service";
import { AcceptTermPayload, SantanderSuitabilityService } from '../../../../services/santander-suitability/santander-suitability.service';
import { CheckoutTermAcceptSidePanelComponent } from '../../../checkout-term-accept-aside-panel/checkout-term-accept-aside-panel.component';
import { SuccessAsidePanelComponent } from "../../../success-aside-panel/success-aside-panel.component";
import { getStopVariation, roundPointsInvestment } from "../../utils/investment-calculation";
import { CheckoutAboutFeesComponent } from '../checkout-about-fees/checkout-about-fees.component';
import { environment } from '@hub-workspace/apps/stock/src/environments/environment';
import { IconType } from '@toro/common/shared/enum/icon-type/icon-type.enum';
import { SantanderGuaranteeIncreaseModalComponent } from '@toro/common/shared/components/santander-guarantee-increase-modal/santander-guarantee-increase-modal.component';

const symbolsAgreement = require('../../../../services/checkout-term-accept/assets/symbols-agreement.json')
@Component({
  templateUrl: "./checkout-resume.component.html",
  styleUrls: ["./checkout-resume.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})

export class CheckoutResumeComponent extends DialogPanelComponentContent {
  public loading: boolean = true;
  public taxDayTrade: number = 10.0;
  public closingTime: string = "16:50";
  public disposableSubscriptions: Subscription[] = [];
  public pending = true;
  public scenarioSettings: CheckoutScenarioSettings = new CheckoutScenarioSettings();
  public suitability: string;
  public hasAgreedToSuitabilityRisk: boolean = false;
  public hasUserCheckedSuitabilityRisk: boolean = false;
  public hasBypassedSuitabilityForCurrentInvestment = false;
  public isStrategy: boolean;
  public consolidatedPosition;
  public stockIdOnList: any;
  private cblc: number;
  public dialogAboutFeesReference: MatDialogRef<CheckoutAboutFeesComponent>;
  public currentFinancialBalance: number;
  public guaranteeValueUsed: number;
  public userCblc: string;
  public finance: FinancePosition;
  public closingTimeDayTrade: string | Date;
  public closingTimeBovespa: string | Date;
  public typeMarketEnum = OrderMarketTypeEnum;
  public cookieExclusiveStatus: string;
  public isExclusive: boolean;
  public hasSendOrderError: boolean;
  public isSantanderSuitabilityEnabled: boolean;
  public santanderProfile: SantanderSuitabilityEnum;
  private shouldAcceptFitting: boolean;
  private fittingAccept: FittingAcceptResponse;
  protected fitting: FittingResponse;
  private santanderOperationLimit: IUserSantanderOperationLimit | null = null;

  public availableToInvest$: Observable<number>;
  public availableGuarantee$: Observable<number>;
  public investments$: Observable<number>;
  public availableAfterInvestment$: Observable<number>;

  @ViewChild('confirmButton', { static: true })
  public confirmButton: ElementRef;
  public isNewBrand = environment.isNewBrand;

  public get isFuture() {
    return this.data.stock.typeMarket === OrderMarketTypeEnum.Future;
  }

  public get feesTooltip(): string {
    return `<div>
      <div class='pop-content'>
        <p>
            <strong class='font-gray-color--darker'>É o valor cobrado quando a corretora precisa encerrar compulsoriamente uma posição de Day Trade alavancada na BM&F ou IBOVESPA, pois ela não foi encerrada manualmente dentro do horário limite.</strong>
        </p>
      </div>
    </div>`;
  }

  public get guaranteeTooltip(): string {
    return `<div>
      <div class='pop-content'>
        <p class="font-gray-color--darker">
            Esse valor é a soma do restante do <strong>saldo</strong> e da <strong>garantia disponíveis para investimentos</strong>.
        </p>
      </div>
    </div>`;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public stocksExchangeCheckoutEffects: StocksExchangeCheckoutEffects,
    public elementRef: ElementRef,
    public store: Store<AppState>,
    private dialogReference: MatDialogRef<CheckoutResumeComponent>,
    protected dialogsServices: DialogsService,
    private icvm617Service: Icvm617Service,
    private router: Router,
    private checkoutNotifierService: CheckoutNotifierService,
    private settings: SettingsService,
    private checkoutTermAcceptService: CheckoutTermAcceptService,
    private tracking: TrackingsService,
    readonly storageService: StorageService,
    private featureFlagService: FeatureFlagService,
    private santanderSuitabilityService: SantanderSuitabilityService,
    private userSantanderService: UserSantanderService,
  ) {
    super(elementRef, true);
    this.createSubscriptions();
    this.getBalance();
    this.initUserCblcListener();

    this.shouldAcceptFitting = this.data.shouldAcceptFitting;
    this.fitting = this.data.fitting;

    this.getFeatureFlagsAndCookies();

    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.MODAL_OPENED, {
      'Product Area Origin': 'Bolsa',
      'Scenario': this.data.stock.isAutomaticCheckout ? 'Encerramento automático' : 'Encerramento manual',
      'Step': 'Resumo',
      'Status': this.data.stock.purchase ? 'Compra de ativo' : 'Venda de ativo',
      'Time Responsável': 'Roebling',
      'specificProperties': {
        'Ticker': this.data.stock.stockId,
        'Is Day Trade': this.data.stock.isDayTrade,
      }
    });

    this.cookieExclusiveStatus = this.storageService.cookie.getItem(
      "hubUserExclusiveStatus"
    );
    this.isExclusive = this.cookieExclusiveStatus == "true";

    this.initializeSelectors();
  }

  private initializeSelectors(): void {
    this.availableToInvest$ = this.store.select(financeSelectors.selectAvailableToInvest(this.data.stock));
    this.availableGuarantee$ = this.store.select(financeSelectors.selectAvailableGuarantee(this.data.stock));
    this.investments$ = this.store.select(financeSelectors.selectInvestments(this.data.stock));
    this.availableAfterInvestment$ = this.store.select(financeSelectors.selectAvailableAfterInvestment(this.data.stock));
  }

  private getFeatureFlagsAndCookies() {
    this.featureFlagService.get().subscribe(featureFlags => {
      this.loading = true;
      // ativar feature flag quando for pro angular 12
      // this.isSantanderSuitabilityEnabled = featureFlags.enableSantanderSuitability;
      this.isSantanderSuitabilityEnabled = true;

      if (this.isSantanderSuitabilityEnabled) {
        this.santanderProfile = getSantanderEnumFromString(this.storageService.cookie.getItem(SantanderSuitabilityCookieKeys.profileName));

        this.loading = false;
      } else { this.loading = false; }
    });
  }

  public createSubscriptions() {
    this.userDataSubscription();
    this.userSuitabilitySubscription();
    this.exchangeCheckoutOrderSubscription();
    this.exchangeCheckoutStrategySubscription();
  }

  public initUserCblcListener = () => {
    this.store.select((state) => state.authentication.currentUser).pipe(
      filter((data) => !!data && !!data.cblc),
      first()
    )
      .subscribe((data) => {
        this.userCblc = data.cblc;
      });
  }

  public get showSuitabilityDisclaimer(): boolean {
    if (this.isSantanderSuitabilityEnabled) {
      return this.shouldAcceptFitting;
    } else {
      return this.suitability !== 'Arrojado' && this.suitability !== 'Sem Perfil' && !this.hasBypassedSuitabilityForCurrentInvestment;
    }
  }

  public get isConfirmDisabled(): boolean {
    return this.loading
      || (this.showSuitabilityDisclaimer
        && (!this.hasUserCheckedSuitabilityRisk || !this.hasAgreedToSuitabilityRisk));
  }

  public onSuitabilityRiskChanged(accepted: boolean): void {
    this.hasAgreedToSuitabilityRisk = accepted;
    this.hasUserCheckedSuitabilityRisk = true;
  }

  public get disclaimerProfileName(): string {
    if (this.isSantanderSuitabilityEnabled) {
      if (!this.santanderProfile) return '';
      const profileName: string = this.santanderProfile.toString();
      return profileName[0].toUpperCase() + profileName.substring(1).toLowerCase();
    } else {
      return this.suitability;
    }
  }

  public getBalance() {
    this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });

    // Se inscreve na store
    this.store.select((store) => store.finance)
      .subscribe((finance) => {
        this.finance = finance.finance;
      });

    this.currentFinancialBalance = this.calculeBalanceByProjectedPosition(this.finance);
    this.guaranteeValueUsed = this.data.guaranteeValueUsed;
  }

  /** Envia o investimento */
  public async sendInvestment() {
    if (this.loading) return;
    this.loading = true;

    this.investments$.pipe(first()).subscribe((currentInvestmentValue: number) => {
        const balanceAvailable = this.consolidatedPosition.totalOperationGuarantee;
        this.icvm617Service.userIsBlocked().subscribe((isBlocked: boolean) => {
          if (isBlocked) {
            this.loading = false;
            this.showWarningUserBlockedIcvm617();
            this.sendCheckoutIntention(CheckoutNotifierActionType.BuyAttempt, "Usuário bloqueado");
          } else {
            if (balanceAvailable < currentInvestmentValue) {
              // Busca o limite operacional Santander para adaptar a mensagem
              this.userSantanderService.getSantanderOperationalLimit(this.userCblc).subscribe(
                (limit) => {

                  console.log(limit);

                  this.loading = false;
                  if (limit.isSantanderCustomer() && !limit.hasAcceptedTerms() && !this.data.stock.isDayTrade) {
                    this.dialogsServices.showSimpleModal(
                      "icon_info",
                      `Saldo insuficiente`,
                      `Você não tem saldo suficiente para fazer esse investimento. Conecte sua conta Santander para ter mais Garantia disponível em Renda Variável.`,
                      `Autorizar comunicação`,
                      false,
                      false,
                      IconType.warning,
                      () => {
                        this.dialogsServices.showComponentAsAsidePanel(
                          SantanderGuaranteeIncreaseModalComponent,
                          true,
                        );

                      }
                    );
                  } else {
                    this.dialogsServices.showSimpleModal(
                      "icon_info",
                      `Garantia insuficiente`,
                      `Você não tem garantia suficiente para fazer esse investimento.
                Você pode transferir mais recursos para a sua conta e tentar novamente.`,
                      `Voltar`
                    );
                  }


                },
                (error) => {
                  // Em caso de erro na busca, mostra a mensagem padrão
                  this.loading = false;
                  console.error('[CheckoutResumeComponent] Error loading Santander limit:', error);
                  this.dialogsServices.showSimpleModal(
                    "icon_info",
                    "Garantia insuficiente",
                    `Você não tem garantia suficiente para fazer esse investimento.
                Você pode transferir mais recursos para a sua conta e tentar novamente.`,
                    `Voltar`
                  );
                }
              );
              this.sendCheckoutIntention(CheckoutNotifierActionType.BuyAttempt, "Saldo insuficiente");
            } else {
              this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
                'Element': 'Botão confirmar investimento',
                'Product Area Origin': 'Bolsa',
                'Scenario': this.data.stock.isAutomaticCheckout ? 'Encerramento automático' : 'Encerramento manual',
                'Step': 'Resumo',
                'Status': this.data.stock.purchase ? 'Compra de ativo' : 'Venda de ativo',
                'Time Responsável': 'Roebling',
                'specificProperties': {
                  'Ticker': this.data.stock.stockId,
                  'Is Day Trade': this.data.stock.isDayTrade,
                }
              });

              if (this.isSantanderSuitabilityEnabled) {
                if (this.shouldAcceptFitting && this.fitting != null) {
                  this.investments$.pipe(first()).subscribe(investments => {
                    const fittingAcceptPayload = new AcceptTermPayload(
                      'T5',
                      'ACOES',
                      investments,
                      this.fitting.investmentFittingValidation.temporaryDocumentId
                    );
                    this.santanderSuitabilityService.acceptTerm(fittingAcceptPayload).subscribe(
                      (data: FittingAcceptResponse) => {
                        this.fittingAccept = data;
                        this.hasSendOrderError = false;
                        this.proceedWithOrder();
                      },
                      (_: any) => {
                        this.hasSendOrderError = true;
                        this.loading = false;
                      }
                    );
                  });
                } else {
                  this.proceedWithOrder();
                }
              } else {
                this.proceedWithOrder();
              }
            }
        }
          },
            (error) => {
              this.loading = false;
              this.dialogsServices.showSimpleModal(
                "icon_info",
                "Não foi possível enviar a ordem com o aceite do termo de adequação",
                `Por favor, tente novamente mais tarde.`,
                `Entendi`
            );
        });
    });
  }

  private async proceedWithOrder() {
    if (this.data.stock.isAutomaticCheckout) {
      this.sendStrategy();
    } else {
      this.stockIdOnList = symbolsAgreement["data"].find((data: any) => data.symbol === this.data.stock.stockId);
      if (!this.stockIdOnList) {
        this.sendOrder();
      } else {
        await this.checkoutTermAcceptService.checkAcceptedContract().pipe(
          tap((result: any) => {
            let hasAlreadyAssigned = false;

            if (result['value'] == null) {
              return false;
            }

            result.value.forEach((value: any) => {
              if (value.contractGUID == this.stockIdOnList.hash) {
                hasAlreadyAssigned = true;
              }
            });

            if (!hasAlreadyAssigned) {
              this.criptoAcceptTerm();
            } else {
              this.sendOrder();
            }
          })
        ).subscribe();
      }
    }
  }

  public criptoAcceptTerm() {
    this.dialogsServices.showComponentAsAsidePanel(
      CheckoutTermAcceptSidePanelComponent,
      true,
      {
        ticker: this.data.stock.stockId,
      }
    ).afterClosed().subscribe(
      (result) => {
        if (result) {
          this.sendOrder();
        }
      }
    );
  }

  public investmentSucess(statusResult) {
    const settings = {
      suitability: this.suitability,
      isScheduleOrder: this.isScheduleOrder(statusResult),
      title: `Ordem de ${this.data.stock.purchase ? "compra" : "venda"} ${this.isScheduleOrder(statusResult) ? "agendada" : "enviada"} com sucesso.`,
      content: "<p>Você pode acessar a área de <strong>Meus Investimentos</strong> dentro de Bolsa para acompanhar a sua ordem.</p>",
      ticker: this.data.stock.stockId,
      cblc: this.cblc,
      purchase: this.data.stock.purchase,
    };
    this.dialogsServices.showComponentAsAsidePanel(SuccessAsidePanelComponent, true, settings);
    this.dialogsServices = null;
    this.closeDialog(true);
    this.pending = false;
  }

  /** Validar quais Status são referentes a agendamento */
  public isScheduleOrder(status: number) {
    switch (status) {
      case OrderStatus.ScheduledReplacement:
      case OrderStatus.ScheduledNew:
        return true;
      default:
        return false;
    }
  }

  /**
   * Fecha o modal
   * @param confirm
   */
  public closeDialog(confirm: boolean) {
    if (!confirm) {
      this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
        'Element': 'Botão voltar',
        'Product Area Origin': 'Bolsa',
        'Scenario': this.data.stock.isAutomaticCheckout ? 'Encerramento automático' : 'Encerramento manual',
        'Step': 'Resumo',
        'Status': this.data.stock.purchase ? 'Compra de ativo' : 'Venda de ativo',
        'Time Responsável': 'Roebling',
        'specificProperties': {
          'Ticker': this.data.stock.stockId,
          'Is Day Trade': this.data.stock.isDayTrade,
        }
      });
    }

    super.close(this.dialogReference, confirm);
    this.dialogReference = null;
  }

  public userDataSubscription() {
    this.disposableSubscriptions.push(
      this.store
        .select((storeAuth) => storeAuth.authentication)
        .pipe(filter((result) => !!result.currentUser))
        .subscribe((result) => {
          this.cblc = result.currentUser.cblc;
        }),

      this.store
        .select((state) => state.finance.consolidatePosition)
        .pipe(filter((consolidatePosition) => !!consolidatePosition))
        .subscribe((consolidatePosition) => {
          this.consolidatedPosition = consolidatePosition;
        })
    );
  }

  public userSuitabilitySubscription() {
    this.disposableSubscriptions.push(
      this.store
        .select((storeSuit) => storeSuit.suitability).pipe(
          filter((result) => !!(result && result.profile))
        )
        .subscribe((result) => {
          this.suitability = result.profile.description;
          this.hasAgreedToSuitabilityRisk = this.hasBypassedSuitabilityForCurrentInvestment = this.suitability === "Arrojado";
        }),

      this.store
        .select((state) => state["suitabilityBypassAgreement"]).pipe(
          filter((data) => !!data)
        )
        .subscribe((data) => {
          if (this.suitability !== "Arrojado") {
            this.hasBypassedSuitabilityForCurrentInvestment = this.hasAgreedToSuitabilityRisk = this.isFuture
              ? data.stock.suitabilityBypassAgreement.bmfAccepted
              : data.stock.suitabilityBypassAgreement.bovespaAccepted;
          }
        })
    );
  }

  public exchangeCheckoutOrderSubscription() {
    this.disposableSubscriptions.push(
      this.stocksExchangeCheckoutEffects.newOrder$
        .pipe(
          filter((item) => {
            return (item.type as any).equals(StocksExchangeCheckoutAction.newOrderSuccess);
          })
        )
        .subscribe((result) => {
          this.sendCheckoutIntention(CheckoutNotifierActionType.OrderSuccess);
          if (result.payload.statusResult) {
            this.investmentSucess(result.payload.statusResult);
          }
        })
    );

    this.disposableSubscriptions.push(
      this.stocksExchangeCheckoutEffects.newOrder$.pipe(filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.newOrderError))).subscribe((result) => {
        this.sendCheckoutIntention(CheckoutNotifierActionType.OrderRejected);
        this.pending = false;
        this.loading = false;
      })
    );
  }

  public exchangeCheckoutStrategySubscription() {
    this.disposableSubscriptions.push(
      this.stocksExchangeCheckoutEffects.newStrategy$
        .pipe(
          filter((item) => {
            return (item.type as any).equals(StocksExchangeCheckoutAction.newStrategySuccess);
          })
        )
        .subscribe((result) => {
          this.sendCheckoutIntention(CheckoutNotifierActionType.OrderSuccess);
          if (result.payload.statusResult) {
            this.investmentSucess(result.payload.statusResult);
          }
        })
    );

    this.disposableSubscriptions.push(
      this.stocksExchangeCheckoutEffects.newStrategy$.pipe(filter((item) => item.type.equals(StocksExchangeCheckoutAction.newStrategyError))).subscribe((result) => {
        this.sendCheckoutIntention(CheckoutNotifierActionType.OrderRejected);
        this.loading = false;
      })
    );
  }

  public composeOrder() {
    const order = new StockOrderType();
    order.symbol = this.data.stock.stockId;
    order.orderQty = this.data.stock.buyAmount;
    order.isDaytrade = this.data.stock.isDayTrade;
    // Preço personalizado
    if (this.data.stock.editedPrice > 0) {
      order.price = this.data.stock.editedPrice;
      order.priceType = StrategyRequestLegPriceType.Limited;
    } else {
      // a mercado
      order.priceType = StrategyRequestLegPriceType.Market;
    }
    // venda ou compra
    order.side = this.data.stock.purchase ? OrderSideEnum.Compra : OrderSideEnum.Venda;
    // day trade
    order.validityType = StrategyRequestLegValidityType.Day;
    order.internalOrderType = StrategyRequestOrderType.Input;
    order.suitabilityNonConformityConsent = this.hasBypassedSuitabilityForCurrentInvestment;

    return order;
  }

  public ngOnDestroy() {
    this.disposableSubscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  private getOriginType() {
    if (this.data.stock.isAutomaticCheckout) return this.data.stock.stopGainVariation || this.data.stock.stopLossVariation ? OrderOriginTypeEnum.Client : OrderOriginTypeEnum.Analyst;
    return OrderOriginTypeEnum.Client;
  }

  private getInputOrder(): StockOrderType {
    const order = new StockOrderType();

    order.symbol = this.data.stock.stockId;
    order.orderQty = this.data.stock.buyAmount;
    order.isDaytrade = this.data.stock.isDayTrade;
    order.originType = this.getOriginType();
    order.suitabilityNonConformityConsent = this.hasBypassedSuitabilityForCurrentInvestment;

    if (!this.isFuture) {
      order.priceType = StrategyRequestLegPriceType.Market;
    } else {
      order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
    }
    order.validityType = StrategyRequestLegValidityType.FillOrKill;
    order.internalOrderType = StrategyRequestOrderType.Input;

    order.side = this.data.stock.purchase ? OrderSideEnum.Compra : OrderSideEnum.Venda;

    return order;
  }

  private getStopLossOrder(): StockOrderType {
    const order = new StockOrderType();

    order.symbol = this.data.stock.stockId;
    order.orderQty = this.data.stock.buyAmount;
    order.isDaytrade = this.data.stock.isDayTrade;
    order.originType = this.getOriginType();

    if (!this.isFuture) {
      order.priceType = StrategyRequestLegPriceType.Market;
    } else {
      order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
    }
    order.validityType = StrategyRequestLegValidityType.FillOrKill; // confirmar
    order.internalOrderType = StrategyRequestOrderType.StopLoss;

    order.price = this.roundWithTwoDecimalPlace(
      this.calculateStopPrice(this.data.stock.purchase, false, this.data.stock.stopLossVariation ? getStopVariation(this.data.stock, false, this.isFuture) : this.data.stock.unitLossPrice)
    );

    if (this.data.stock.stopLossVariation) {
      order.paramLoss = this.isFuture ? roundPointsInvestment(getStopVariation(this.data.stock, false, this.isFuture)) : this.roundWithTwoDecimalPlace(getStopVariation(this.data.stock, false, this.isFuture));
    } else if (this.isFuture) {
      order.paramLoss = this.roundWithTwoDecimalPlace(
        this.data.stock.purchase
          ? this.data.stock.unitPrice - this.calculateStopPrice(this.data.stock.purchase, false, this.data.stock.unitLossPrice)
          : this.calculateStopPrice(this.data.stock.purchase, false, this.data.stock.unitLossPrice) - this.data.stock.unitPrice
      );
    } else {
      order.paramLoss = this.roundWithTwoDecimalPlace(100 - (order.price / this.data.stock.unitPrice) * 100) * (this.data.stock.purchase ? 1 : -1);
    }
    // para ordens de Stop Gain e Loss o lado é o contrário do input
    order.side = this.data.stock.purchase ? OrderSideEnum.Venda : OrderSideEnum.Compra;

    return order;
  }

  private getStopGainOrder(): StockOrderType {
    const order = new StockOrderType();

    order.symbol = this.data.stock.stockId;
    order.orderQty = this.data.stock.buyAmount;
    order.isDaytrade = this.data.stock.isDayTrade;
    order.originType = this.getOriginType();

    if (!this.isFuture) {
      order.priceType = StrategyRequestLegPriceType.Market;
    } else {
      order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
    }
    order.validityType = StrategyRequestLegValidityType.FillOrKill;
    order.internalOrderType = StrategyRequestOrderType.StopGain;

    order.price = this.roundWithTwoDecimalPlace(
      this.calculateStopPrice(this.data.stock.purchase, true, this.data.stock.stopGainVariation ? getStopVariation(this.data.stock, true, this.isFuture) : this.data.stock.unitGainPrice)
    );
    if (this.data.stock.stopGainVariation) {
      order.paramGain = this.isFuture ? roundPointsInvestment(getStopVariation(this.data.stock, true, this.isFuture)) : this.roundWithTwoDecimalPlace(getStopVariation(this.data.stock, true, this.isFuture));
    } else if (this.isFuture) {
      order.paramGain = this.roundWithTwoDecimalPlace(
        this.data.stock.purchase
          ? this.data.stock.unitPrice - this.calculateStopPrice(this.data.stock.purchase, false, this.data.stock.unitGainPrice)
          : this.calculateStopPrice(this.data.stock.purchase, false, this.data.stock.unitGainPrice) - this.data.stock.unitPrice
      );
    } else {
      order.paramGain = this.roundWithTwoDecimalPlace((order.price / this.data.stock.unitPrice) * 100 - 100) * (this.data.stock.purchase ? 1 : -1);
    }
    // para ordens de Stop Gain e Loss o lado é o contrário do input
    order.side = this.data.stock.purchase ? OrderSideEnum.Venda : OrderSideEnum.Compra;

    return order;
  }

  // Envia o aceite do usuário de investimento incompativel com perfil de suitability
  private _suitabilityBypass() {
    if (!this.hasBypassedSuitabilityForCurrentInvestment) {
      this.store.dispatch({ type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreement, payload: { data: { "marketType": this.isFuture ? "Future" : "Bovespa" } } });
      this.hasBypassedSuitabilityForCurrentInvestment = true;
    }
  }

  private sendOrder() {
    this._suitabilityBypass();

    const order = this.composeOrder();
    this.store.dispatch({ type: StocksExchangeCheckoutAction.newOrder, payload: { data: order } });

    const currentUrl: String = this.router.url;
    let productAreaOrigin: String;
    if (currentUrl.includes('explore-o-mercado')) {
      productAreaOrigin = 'Explore o mercado';
    } else if (currentUrl.includes('acompanhamento')) {
      productAreaOrigin = 'Acompanhamento do ativo';
    } else if (currentUrl.includes('analise')) {
      productAreaOrigin = 'Análise do ativo';
    }

    this.tracking.sendMetricsToMixpanel('Order Sent', {
      'Product Area Origin': productAreaOrigin,
      'Day Trade': order.isDaytrade,
      'Configuration Type': this.data.stock.isAutomaticCheckout
        ? 'Automático'
        : 'Manual',
      'Market Type': this.isFuture
        ? SegmentMarketTypeEnum.BMF
        : SegmentMarketTypeEnum.BOVESPA,
      'Order Type': this.data.stock.purchase
        ? 'Open position'
        : 'Close position',
      Quantity: order.orderQty,
      Direction: this.data.stock.purchase ? 'Compra' : 'Venda',
      Ticker: order.symbol,
      Price: order.price,
      'Time Responsável': 'Roebling',
      specificProperties: {
        Guarantee: this.guaranteeValueUsed,
        'Is Guarantee Used': this.guaranteeValueUsed > 0,
        'Price Mode': !!this.data.stock.editedPrice
          ? 'Personalizado'
          : 'A mercado'
      },
      'Non-compliant Suitability': this.shouldAcceptFitting,
    });
  }

  private sendStrategy() {
    this._suitabilityBypass();

    const legs: StockOrderType[] = [this.getInputOrder(), this.getStopGainOrder(), this.getStopLossOrder()];
    const originType: number = this.getOriginType();

    const strategy: StrategyRequest = new StrategyRequest(this.data.stock.stockId, this.data.stock.isDayTrade, 0, originType, legs);
    this.store.dispatch({ type: StocksExchangeCheckoutAction.newStrategy, payload: { data: strategy } });
  }

  private roundWithTwoDecimalPlace(value: number) {
    return Math.ceil(value * 100) / 100;
  }

  private calculateStopPrice(purchase: boolean, gain: boolean, variation: number) {
    if ((purchase && !gain) || (!purchase && gain)) {
      variation = variation * -1;
    }
    return this.data.stock.typeMarket === OrderMarketTypeEnum.Future ? this.data.stock.unitPrice + variation : this.data.stock.unitPrice * (1 + variation / 100);
  }

  /**
   * Função que dispara evento pro mixpanel
   *
   * @param typeAction título da action
   * @param eventsTracking objeto de eventos
   */
  public sendToTracking(typeAction, eventsTracking) {
    const payloadUser = { type: typeAction, events: eventsTracking };
    this.store.dispatch({ type: TrackingActions.trackEvents, payload: payloadUser });
  }

  private sendCheckoutIntention(userActionType: CheckoutNotifierActionType, message?: string) {
    const operationMethod: string = this.data.stock.isAutomaticCheckout ? "Automatica" : "Manual";
    const isDayTrade = this.data.stock.isDayTrade ? "*habilitado*" : "*desabilitado*";

    const notifierMessage = message ? message : `Operação ${operationMethod} com Day Trade ${isDayTrade}`;
    const minimumAmountToNotify = this.settings.getConfigurationKeyValue("minimumAmountToNotify");

    if (this.data.stock.purchase && this.consolidatedPosition.accountBalance >= minimumAmountToNotify) {
      this.checkoutNotifierService
        .sendCheckoutNotifierIntention({
          "cblc": this.cblc,
          "dateOperation": new Date().getTime(),
          "productType": CheckoutNotifierProductType.BOLSA,
          "userActionType": userActionType,
          "items": [
            {
              "id": 0,
              "name": `${this.data.stock.stockId}, Qtd: ${this.data.stock.buyAmount}`,
            },
          ],
          "message": notifierMessage,
        })
        .subscribe();
    }
  }

  private showWarningUserBlockedIcvm617() {
    const message = `<p>A Resolução 50 da CVM exige que todos os investidores atualizem algumas informações de cadastro.
            Por isso, até que você atualize os seus dados, <b>sua conta está bloqueada para novas operações</b>.

            <br/> <br/>
            Clique no botão abaixo para conferir as informações e voltar a investir normalmente.</p><br/>`;

    this.dialogsServices.confirmDestructiveAction("Atualize seus dados cadastrais para concluir a operação", message, "Atualizar dados cadastrais", "Deixar para depois").subscribe((data) => {
      if (data) {
        this.router.navigate(["minha-conta/risco/edit"]);
      }
    });
  }

  public aboutFeesCall() {
    const reference = this.dialogsServices.showComponentAsAsidePanel(CheckoutAboutFeesComponent, true);
    this.dialogAboutFeesReference = reference as MatDialogRef<CheckoutAboutFeesComponent>;

    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
      'Element': 'Link como funciona a taxa de zeragem ',
      'Product Area Origin': 'Bolsa',
      'Group': this.data.stock.isAutomaticCheckout ? 'Encerramento automático' : 'Encerramento manual',
      'Step': 'Resumo',
      'Scenario': 'Checkout',
      'Status': this.data.stock.purchase ? 'Compra de ativo' : 'Venda de ativo',
      'Time Responsável': 'Roebling',
      'specificProperties': {
        'Ticker': this.data.stock.stockId,
        'Market Type': this.isFuture ? "Future" : "Bovespa",
        'Is Day Trade': this.data.stock.isDayTrade,
      }
    });
  }

  public calculeBalanceByProjectedPosition(financePosition: FinancePosition): number {
    return financePosition.availableOnAccountD0 + this.getProjectedRisk(this.finance);
  }

  private getProjectedRisk(financePosition: FinancePosition): number {
    return financePosition.projectedD1 + financePosition.projectedD2;
  }
}
